<template>
  <div
    v-loading="loadHistory"
    class="cousreing_box cousreing_next"
  >
    <div class="cousre_header">
      <slot name="cousreTitle" />
      (
      <em>{{ filteredCourseHistoryLength }}</em>
      )
      <button
        class="button_E330 buttonRefresh"
        :class="!isDoCardsetResresh?'button_eventNone_E330':''"
        @click="cardsetResresh"
      >
        {{ $t('devicecard.refresh') }}&nbsp;<i :class="!isDoCardsetResresh?'el-icon-time':'el-icon-refresh'" />
      </button>
    </div>
    <!-- <i class="el-icon-close text-button" @click="close"></i> -->
    <div class="course_prcess">
      <vuescroll>
        <div
          v-for="(item, index) in courseHistory"
          :key="item.index"
        >
          <div
            v-if="item.ResultCode !== 1"
            class="course_list"
          >
            <div
              v-if="item.ResultCode !== 1"
              class="course_cont"
            >
              <!-- <span class="prcess_index" v-html="index + 1 + '.<br>' + (item.TransType?(typeTranslate[item.TransType+''] || ''):'')"></span> -->
              <span class="prcess_index">{{ index + 1 }} <br>
                <template v-if="areaTreeType == 3">
                  <template v-if="item.IFtttType == 1">{{ typeTranslate['2'] }}</template>
                  <template v-else-if="item.IFtttType == 5">{{ typeTranslate['9'] }}</template>
                  <template v-else-if="item.IFtttType == 6">{{ typeTranslate['10'] }}</template>
                </template>
                <template v-else>
                  {{ (item.TransType?(typeTranslate[item.TransType+''] || ''):'') }}
                </template>
              </span>
              <!-- this.areaTreeType == 3 -->
              <div class="course_card">
                <div
                  class="course_left"
                  :class="[item.isknow ? 'warnShadow' : '']"
                >
                  <div
                    v-if="item.ProtocolTypeList&&item.ProtocolTypeList.length === 1"
                    class="card_badge"
                    :title="item.ProtocolTypeList&&item.ProtocolTypeList[0].Name"
                  >
                    <em>{{ item.ProtocolTypeList[0].Name }}</em>
                  </div>
                  <div
                    v-else-if="item.ProtocolTypeList&&item.ProtocolTypeList.length >= 2"
                    class="card_badge"
                    title="MIX"
                  >
                    <em>MIX</em>
                  </div>
                  <img
                    v-if="$store.state.isLocalServer"
                    class="card_img"
                    :src="getClassSkuImage(item,'on','../../assets/img/d_f1.png')"
                  >
                  <img
                    v-else
                    class="card_img"
                    :src="getImgUrlState(item,'on')"
                  >
                </div>
                <div class="course_right">
                  <p
                    class="course_name"
                    :title="item.DeviceName"
                  >
                    {{ item.DeviceName }}
                  </P>
                  <p
                    class="course_block"
                    :title="item.ParentAreaNames"
                  >
                    {{ $t('sync.areaname') }}：{{ item.ParentAreaNames }}
                  </P>
                  <p
                    class="course_time"
                    :title="timeOffset(item.ConfigTime)"
                  >
                    {{ $t('sync.time') }}：{{ timeOffset(item.ConfigTime) }}
                  </P>
                </div>
                <el-button
                  class="course_know de_course_know"
                  @click="Identification(item)"
                >
                  {{ $t('sync.identification') }}
                </el-button>
                <el-button
                  v-if="item.ChannelName"
                  class="operate_button"
                >
                  {{ item.ChannelName }}
                </el-button>
              </div>

              <div class="course_state">
                <!-- <div class="state_faile" v-if="item.ResultCode == 2"> -->
                <div
                  v-if="item.ResultCode == 2"
                  class="state_faile"
                >
                  <i class="icon-11" />
                  <div class="course_button">
                    <el-button
                      class="blue"
                      @click="retry(item)"
                    >
                      {{ $t('sync.retry') }}
                    </el-button>
                  </div>
                </div>
                <div
                  v-if="item.ResultCode == 0"
                  class="state_faile"
                >
                  <span style="display: block;margin-bottom: 16px;margin-top: 8px;">{{ $t('sync.synchronizing') }}</span>
                  <!-- <button class="state_last_sel" @click="delSync(item)">{{$t('sync.delete')}}</button> -->
                  <div class="course_button">
                    <el-button
                      class="blue"
                      @click="retry(item)"
                    >
                      {{ $t('sync.retry') }}
                    </el-button>
                  </div>
                </div>
                <i
                  v-show="item.ResultCode == 1"
                  class="state_sucess icon-5"
                />
              </div>
            </div>
          </div>
        </div>
      </vuescroll>
    </div>
    <div class="course_box clearfix">
      <el-button
        v-intervalclick="{func:goingTry}"
        class="curse_go fleft"
      >
        {{ $t('sync.alltry') }}
      </el-button>
      <el-button
        class="curse_try fright"
        @click="backgroundDo"
      >
        {{ $t('base.cancel') }}
      </el-button>
    </div>
    <template v-if="imgDialog">
      <el-dialog
        :modal-append-to-body="false"
        :title="$t('devicecard.dowarn')"
        :visible.sync="imgDialog"
        class="imgDialog"
        width="30%"
        append-to-body
        :before-close="handleClose"
      >
        <img
          class="Dialogimg"
          :src="imgsrc"
        >
        <div class="Dialogimg">
          {{ imgsrcDesc }}
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
//0-同步中 1-成功  2-失败 3- 默认
import vuescroll from 'vuescroll';
import { FindDeviceSyncResult, GetIdentifyInfo, PositiveIdentify, ReSyncProjectCode, ReSyncSmartConfig, GetUIGuideDataList } from '@/axios/IDevice.js';
import { ShowHistorySyncResult, ReSyncAreaCode, ShowCurrentSyncResult } from '@/axios/IArea.js';
import { ShowIftttHistorySyncResult, ShowIftttCurrentSyncResult, ReSyncIftttDeviceConfig, ReSyncConstIlluminationConfig, ReSyncRhythmConfig } from '@/axios/IFttt.js';
import { ShowSceneHistorySyncResult, ShowSceneCurrentSyncResult, ReSyncDeviceConfig } from '@/axios/IScene.js';
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js';
import { getImgUrlState } from "@/utils/utils";
import { postWebIOSocket } from '@assets/socket';

export default {
  name: 'Course', //searchtype 1当前 2/历史 removecurrent当前面板的参数
  components: {
    vuescroll
  },
  props: ['courseid', 'areaTreeType', 'searchtype', 'removecurrent', 'isDeviece'],
  data() {
    return {
      loadHistory: false, //是否加载
      courseHistory: [], //数据
      socketpara: {}, //socket对象
      pollingclock: null, //定时器 已取消
      totalTime: 130, //定时时间 已取消
      imgDialog: false, //是否弹出识别图片
      imgsrc: '', //识别图片
      imgsrcDesc: '',
      typeTranslate: {
        '0': this.$t('sync.area'),
        '1': this.$t('sync.scene'),
        '2': this.$t('sync.ifttt'),
        '4': this.$t('sync.config'),
        '5': this.$t('sync.projectId'),
        '10': this.$t('sync.constIllumination'),
        '9': this.$t('sync.rhythm')
      }, //描述
      isDoCardsetResresh: true, //是否可执行刷新
      ardsetResreshTotalTime: 1000, //执行刷新间隔5秒
      identifNone:this.$t('devicecard.identifNone')
    };
  },
  computed: {
    socketmodel() {
      return this.$store.state.socketmodel;　　//需要监听的数据
    },
    filteredCourseHistoryLength() {
      return this.courseHistory.filter(item => item.ResultCode !== 1).length;
    }
  },
  watch: {
    socketmodel(rs, old) {
      //监听socket
      this.functionScoketsync_info_event(rs);
      // if(JSON.stringify(rs)!=JSON.stringify(old)){
      // 	console.log('不一样');
      //
      // }else{
      // 	console.log('一样');
      // }
    }
  },
  mounted() {
    //初始化加载数据
    this.isDoCardsetResresh = true;

    this.doShowHistorySyncResult();

  },
  destroyed() {
    //页面销毁 情况计时器
    this.clearIntervalTime();
    //socket.emit('sync_info_remove_event', this.socketpara);
  },
  // computed:{
  // 	coursedata() {
  // 		console.log(this.socketpara);
  // 		if(this.socketpara.data.type==23){
  // 			console.log('1233');
  // 			this.courseHistory.forEach(n=>{
  // 				if(n.ResultCode==0){
  // 					console.log(n.ConfigTime.replace('T',' '));
  // 				}
  // 				//new Date(date)
  // 				//n.endTime=
  // 			})
  // 		}
  // 		return this.courseHistory;
  // 	}
  // },
  methods: {
    getImgUrlState:getImgUrlState,
    /* 关闭看板
    */
    close() {
      this.$emit('closeCourse');
    },
    /* 关闭看板
    */
    handleClose(done) {
      done();
      this.imgsrc = '';
      this.imgsrcDesc = '';;
    },
    /* 清空计时器
    */
    clearIntervalTime() {
      //清楚计时器
      clearInterval(this.pollingclock);
    },
    /* socket推送过来的数据处理
    * rs:推送原始数据包
    */
    functionScoketsync_info_event(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        var n, i = 0, l = this.courseHistory.length;
        if (rs.Result[0].Type == 3) {
          //被动识别
          this.imgDialog = false;
          this.courseHistory.forEach(n => {
            if (n.Mac == rs.Result[0].DeviceMac) {
              n.isknow = true;
              //socket.emit('sync_info_remove_event', { data: [{ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac }] });
              setTimeout(() => {
                n.isknow = false;
              }, 2000);
            }
          });
        } else if (rs.Result[0].Type == 19) {
          // console.log(rs);
          // console.log('场景同步返回');
          if (this.areaTreeType == 2) {
            this.courseHistory.forEach(n => {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.SceneId == rs.Result[0].SceneId) {
                n.ResultCode = 1;
              }
            });
          } else if (this.areaTreeType == 4) {

            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 1 && n.VDeviceId == rs.Result[0].VDeviceId && n.SourceId == rs.Result[0].SceneId) {
                n.ResultCode = 1;
              }
            }
          }
          this.$emit('returncall');
        } else if (rs.Result[0].Type == 20) {
          // console.log(rs);
          // console.log('自动化同步返回');
          if (this.areaTreeType == 3) {
            this.courseHistory.forEach(n => {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.IFtttNo == rs.Result[0].IFtttNo) {
                n.ResultCode = 1;
              }
            });
          } else if (this.areaTreeType == 4) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 2 && n.VDeviceId == rs.Result[0].VDeviceId && n.SourceId == rs.Result[0].IFtttNo) {
                n.ResultCode = 1;
                break;
              }
            }
          }
          this.$emit('returncall');
        } else if (rs.Result[0].Type == 21) {
          // console.log(rs);
          // console.log('区域同步返回');
          if (this.areaTreeType == 1) {
            this.courseHistory.forEach(n => {
              if (n.VDeviceId == rs.Result[0].VDeviceId && n.ChannelId == rs.Result[0].ChannelId && n.GpNo == rs.Result[0].GpNo) {
                n.ResultCode = 1;
              }
            });
          } else if (this.areaTreeType == 4) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 0 && n.VDeviceId == rs.Result[0].VDeviceId && n.ChannelId == rs.Result[0].ChannelId) {
                n.ResultCode = 1;
                break;
              }
            }
          }
          this.$emit('returncall');
        } else if (rs.Result[0].Type == 23) {
          // console.log(rs);
          // console.log('配置同步返回');
          if (this.areaTreeType == 4) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 4 && n.VDeviceId == rs.Result[0].VDeviceId && n.SourceId == rs.Result[0].CommandKey) {
                n.ResultCode = 1;
                break;
              }
            }
          }
        } else if (rs.Result[0].Type == 22) {
          // console.log(rs);
          // console.log('项目同步返回');
          if (this.areaTreeType == 4) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 5 && n.VDeviceId == rs.Result[0].VDeviceId) {
                n.ResultCode = 1;
                break;
              }
            }
          }
        } else if (rs.Result[0].Type == 17) {
          // console.log(rs);
          // console.log('恒照度同步返回');
          if (this.areaTreeType == 4) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 10 && n.VDeviceId == rs.Result[0].VDeviceId && n.SourceId == rs.Result[0].ConstantIlluminationId) {
                n.ResultCode = 1;
                break;
              }
            }
          }
          this.$emit('returncall');
        } else if (rs.Result[0].Type == 18) {
          // console.log(rs);
          // console.log('节律同步返回');
          if (this.areaTreeType == 4) {
            for (; i < l; i++) {
              n = this.courseHistory[i];
              if (n.TransType == 9 && n.VDeviceId == rs.Result[0].VDeviceId && n.SourceId == rs.Result[0].RhythmNo) {
                n.ResultCode = 1;
                break;
              }
            }
          }
          this.$emit('returncall');
        }
        n = null;
        i = null;
        l = null;
      }
    },
    /* 设置计时器
    */
    doPolling() {
      this.pollingclock = window.setInterval(this.computeData, 1000);
    },
    /* 计时器计算
    */
    computeData() {
      this.totalTime--;
      if (this.totalTime <= 0) {
        this.totalTime = 130;
        this.clearIntervalTime();
      } else {
        this.courseHistory.forEach(n => {
          if (n.ResultCode == 0 && this.searchtype == 1) {
            var _nowtime = new Date();
            if (n.endTime < _nowtime) {
              n.ResultCode = 2;
            }
          }
        })
      }

    },
    /* 获得看板数据 处理数据格式
    * rs:接口返回的原始数据包
    */
    functionDoNotice(rs) {

      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // console.log(rs);
        var paramac = { data: [] };
        var _arrmac = [];
        rs.Result.forEach(n => {
          if (this.searchtype == 1) {
            var ishassclock = false;
            if (n.ResultCode == 0) {
              //console.log();
              var _time = new Date(n.ConfigTime.replace('T', ' '));
              _time.setMinutes(_time.getMinutes() + 1);

              n.endTime = _time;
              _time = null;
              ishassclock = true;
            }
            // if(ishassclock){
            // 	this.doPolling();
            // }
          }
          n.isknow = false;
          if (n.IsBind) {
            _arrmac.push({ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac });
          }

        })
        this.courseHistory = rs.Result;
        paramac.data = _arrmac;
        if (paramac.data.length > 0) {
          //socket.emit('sync_info_add_event', paramac);
          postWebIOSocket('sync_info_add_event', paramac);
        }
        paramac = null;
        _arrmac = null;
      }
      this.loadHistory = false;
      this.$emit('historycount', this.courseHistory.length);
    },
    doSocket(_list) {

    },
    /* 获取看板数据 searchtype为1 说明是同步看板 其他则是历史看板 根据areaTreeType 判断是区域1 场景2 自动化3 同时注册socket
    */
    doShowHistorySyncResult() {

      this.courseHistory = [];
      // if (this.courseid != -1) { //&& this.courseid != 0
      this.socketpara.data = [];
      if (this.areaTreeType == 1) {
        //区域
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 21, id: this.$store.state.projectcode });
      } else if (this.areaTreeType == 2) {
        //场景
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 19, id: this.$store.state.projectcode });
      } else if (this.areaTreeType == 3) {
        //自动化
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 20, id: this.$store.state.projectcode });
      } else if (this.areaTreeType == 4) {
        //参数配置同步看板 （临时加了项目看版 areaTreeType=5)
        this.socketpara.data.push({ projectCode: this.$store.state.projectcode, type: 23, id: this.$store.state.projectcode },
          { projectCode: this.$store.state.projectcode, type: 22, id: this.$store.state.projectcode },
          { projectCode: this.$store.state.projectcode, type: 17, id: this.$store.state.projectcode },
          { projectCode: this.$store.state.projectcode, type: 18, id: this.$store.state.projectcode });
      }
      if (this.socketpara.data.length > 0) {
        postWebIOSocket('sync_info_add_event', this.socketpara);
      }
      if (this.searchtype == 1) {
        if (this.areaTreeType == 1) {
          //区域
          ShowCurrentSyncResult(this.removecurrent, this.functionDoNotice);
        } else if (this.areaTreeType == 2) {
          //场景
          ShowSceneCurrentSyncResult(this.removecurrent[0], this.functionDoNotice);
        } else if (this.areaTreeType == 3) {
          //自动化 （接口需完善）
          ShowIftttCurrentSyncResult(this.removecurrent[0], this.functionDoNotice);
        } else if (this.areaTreeType == 4) {
          //参数配置同步看板（待完善）

          if (this.courseid != null) {
            FindDeviceSyncResult({ vDeviceId: this.courseid }, this.functionDoNotice);
          }
        }
      } else {
        this.loadHistory = true;

        var para = this.isDeviece ? { vDeviceId: this.courseid } : { gpNo: this.courseid };
        if (this.areaTreeType == 1) {
          //区域
          ShowHistorySyncResult(para, this.functionDoNotice);
        } else if (this.areaTreeType == 2) {
          //场景
          ShowSceneHistorySyncResult(para, this.functionDoNotice);
        } else if (this.areaTreeType == 3) {
          //自动化
          ShowIftttHistorySyncResult(para, this.functionDoNotice);
        }
        para = null;
      }
      // }
    },

    functionDoReSyncAreaCode(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    /* 点击区域重试
    * item 设备对象
    * isParam：
    */
    doReSyncAreaCode(item, isParam) {
      //区域重试
      var para = { gpNo: item.GpNo, vDeviceId: item.VDeviceId, channelId: item.ChannelId };
      ReSyncAreaCode(isParam ? item : para, this.functionDoReSyncAreaCode);
      item.ResultCode = 0;
      para = null;
    },
    /* 点击场景重试
    * item 设备对象
    * isParam：
    */
    doReSyncDeviceConfig(item, isParam) {//场景
      var para = { sceneNo: item.SceneId, vDeviceId: item.VDeviceId, channelId: item.ChannelId };
      ReSyncDeviceConfig(isParam ? item : para, this.functionDoReSyncDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    /* 点击ifttt重试
    * item 设备对象
    * isParam：
    */
    doReSyncIftttDeviceConfig(item, isParam) {
      var para = { iftttNo: item.IFtttNo, vDeviceId: item.VDeviceId, executeType: item.ExecuteType };
      ReSyncIftttDeviceConfig(isParam ? item : para, this.functionDoReSyncIftttDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncConstIlluminationConfig(item, isParam) {
      var para = { constIlluminationNo: item.constIlluminationNo, vDeviceId: item.VDeviceId, executeType: item.ExecuteType };
      ReSyncConstIlluminationConfig(isParam ? item : para, this.functionDoReSyncIftttDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncRhythmConfig(item, isParam) {
      var para = { rhythmNo: item.rhythmNo, vDeviceId: item.VDeviceId, executeType: item.ExecuteType };
      ReSyncRhythmConfig(isParam ? item : para, this.functionDoReSyncIftttDeviceConfig);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncProjectCode(item, isParam) {
      //区域重试
      var para = { vDeviceId: item.VDeviceId };
      ReSyncProjectCode(isParam ? item : para, this.functionDoReSyncProjectCode);
      item.ResultCode = 0;
      para = null;
    },
    doReSyncSmartConfig(item, isParam) {
      //参数重试

      var para = { commandKey: item.SourceId, vDeviceId: item.VDeviceId };
      ReSyncSmartConfig(isParam ? item : para, this.functionDoReSyncProjectCode);
      item.ResultCode = 0;
      para = null;
    },

    functionDoReSyncDeviceConfig(rs) {
      //console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    functionDoReSyncIftttDeviceConfig(rs) {
      // console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    functionDoReSyncProjectCode(rs) {
      // console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //this.doShowHistorySyncResult();
      }
    },
    retry(item, isNoTitle) {
      //重试

      if (item.ResultCode == 0 && isNoTitle != true) {
        warning(this, this.$t('sync.retry') + '-' + this.$t('sync.synchronizing'));
      }

      if (this.areaTreeType == 1) {
        this.doReSyncAreaCode(item);
      } else if (this.areaTreeType == 2) {
        this.doReSyncDeviceConfig(item);
      } else if (this.areaTreeType == 3) {
        this.doReSyncIftttDeviceConfig(item);
      } else if (this.areaTreeType == 4) {
        //this.doReSyncIftttDeviceConfig(item);
        if (item["TransType"] == 0) {//area
          item.ResultCode = 0;
          this.doReSyncAreaCode({ "gpNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "channelId": item["ChannelId"] }, true);
        } else if (item["TransType"] == 1) {//scene
          item.ResultCode = 0;
          this.doReSyncDeviceConfig({ "sceneNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "channelId": item["ChannelId"] }, true);
        } else if (item["TransType"] == 2) {//ifttt
          item.ResultCode = 0;
          this.doReSyncIftttDeviceConfig({ "iftttNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
        } else if (item["TransType"] == 4) {//deviceConfig
          item.ResultCode = 0;
          this.doReSyncSmartConfig({ "commandKey": item["SourceId"], "vDeviceId": item["VDeviceId"] }, true);
        } else if (item["TransType"] == 5) {//project
          item.ResultCode = 0;
          this.doReSyncProjectCode({ "vDeviceId": item["VDeviceId"] }, true);
        } else if (item["TransType"] == 10) {//constIllumination 恒照度
          item.ResultCode = 0;
          this.doReSyncConstIlluminationConfig({ "constIlluminationNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
        } else if (item["TransType"] == 9) {//rhythm 节律
          item.ResultCode = 0;
          this.doReSyncRhythmConfig({ "rhythmNo": item["SourceId"], "vDeviceId": item["VDeviceId"], "executeType": item["ExecuteType"] }, true);
        }
      }
    },
    // delSync(item) {
    //删除
    // console.log('删除');
    // },
    /* 识别接收的方法 实现卡片闪动
    * rs 接口返回原始数据包
    * para：接口的参数
    * model：设备对象
    */
    functionDoPositiveIdentify(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        model.isknow = true;
        setTimeout(() => {
          model.isknow = false;
        }, 2000);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 对主动识别跟被动识别的处理 主动下发指令
    * rs 接口返回原始数据包
    * model：设备对象
    */
    doPositiveIdentify(result, model) {
      if (result.IdentifyType == 1 || result.IdentifyType == 2) {
        //被动识别
        //this.dosocket(model);
        //console.log(model);
        // var _imgurl = '';
        // if (model.ClassSku == "0x02000308") {
        //   _imgurl = "/static/device/identify/nonev2.png";
        // } else if (result.IntroImage == '' || result.IntroImage == null || result.IntroImage.indexOf('http') != -1) {
        //   _imgurl = '/static/device/identify/none.png';
        // } else {
        //   _imgurl = '/static/device/identify/' + result.IntroImage;
        // }
        // this.imgsrc = _imgurl;
        // this.imgsrcDesc = result["IntroDesc"] || '';
        // this.imgDialog = true;
        // _imgurl = null;
        const para = {
          type: 2,
          classSku: model.ClassSku,
          appType: 3
        }


        GetUIGuideDataList(para, this.functionGetUIGuideDataList, model);
      } else {
        var para = { mac: model.Mac, deviceId: model.VDeviceId, channelId: model.ChannelId };
        PositiveIdentify(para, this.functionDoPositiveIdentify, model);
        para = null;
      }
    },
    /**
        * 获取引导页资源
        * @para {1 | 2 } type 1:SSid 更换引导; 2:被动识别
        * @para {1 | 2 | 3 } appType app类型，1:欧普智慧灯光;2:欧普智能家庭;3:商照
        * @returns {Promise} request promise
        */
    functionGetUIGuideDataList(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        const array = ['0x02000301', '0x02000306', '0x02000307', '0x02000308', '0x0200030C']

        const arrIndex = array.findIndex(item => {
          return item === model.ClassSku
        })

        if (arrIndex !== -1) {
          this.imgsrcDesc = [{
            Type: 'img', Value: rs.Result[0].Value
          }, {
            Type: 'txt',
            Value: this.$t('devicecard.identif1')
          }]
          this.imgDialog = true;
          return
        } else if (model.ClassSku == "0x02000202") {
          this.imgsrcDesc = [{
            Type: 'img', Value: rs.Result[0].Value
          }, {
            Type: 'txt',
            Value: this.$t('devicecard.identif2')
          }]
          this.imgDialog = true;
          return
        }

        if (rs.Result.length > 0) {
          this.imgsrcDesc = rs.Result
          this.imgDialog = true;
        } else {
          this.imgsrcDesc = [{
            // Type: 'img', Value: '../../static/device/identify/none.png'
            Type: 'img', Value: require('@static/device/identify/none.png')
          }, {
            Type: 'txt',
            Value: this.identifNone
          }]
          this.imgDialog = true;
        }

      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 获得设备的识别方式 接口返回的数据处理
    * rs 接口返回原始数据包
    * para：提交的参数
    * model：设备对象
    */
    functionDoGetIdentifyInfo(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //去识别

        this.doPositiveIdentify(rs.Result, model);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 获得设备的识别方式
    * model：设备对象
    */
    doGetIdentifyInfo(model) {
      // logOutUser
      //查询设备认领方式
      // console.log(model);
      var para = { classSku: model.ClassSku, channelId: model.ChannelId };
      GetIdentifyInfo(para, this.functionDoGetIdentifyInfo, model);
      para = null;
    },
    /* 点击页面识别按钮
    * item：设备对象
    */
    Identification(item) {
      //点击识别
      // console.log('识别');
      // this.imgDialog=true;
      this.doGetIdentifyInfo(item);
    },
    /* 点击后台执行
    */
    backgroundDo() {
      this.$emit('backgroundDo');
    },
    /* 点击全部重试
    */
    goingTry() {
      if (this.courseHistory.length > 0) {
        // warning(this, this.$t('sync.retry') + '-' + this.$t('sync.synchronizing'));
        this.courseHistory.forEach(item => {
          if (item.ResultCode != 1) {
            //2失败 0同步中 1成功
            //if(item.ResultCode==2){
            //失败的重试
            this.retry(item, true);
            // if (this.areaTreeType == 1) {
            // 	this.doReSyncAreaCode(item);
            // } else if (this.areaTreeType == 2) {
            // 	this.doReSyncDeviceConfig(item);
            // } else if (this.areaTreeType == 3) {
            // 	this.doReSyncIftttDeviceConfig(item);
            // }
          }

        });
      }
      //this.$emit('alltry',this.courseHistory);
    },
    cardsetResresh() {
      if (!this.isDoCardsetResresh) { return; }
      this.isDoCardsetResresh = false;
      let ardsetResreshTotalClock = window.setInterval(() => {
        this.ardsetResreshTotalTime--;
        if (this.ardsetResreshTotalTime < 0) {
          window.clearInterval(ardsetResreshTotalClock);
          this.ardsetResreshTotalTime = 1000;
          this.isDoCardsetResresh = true;
        }
      });
      this.doShowHistorySyncResult();
    }
  }
};
</script>

<style lang="scss" scoped>
/* 数据同步面板组件	 */
.cousre_header {
  color: #202020;
  em {
    font-style: normal;
    color: #4f8ee7;
  }
}
.card_img{
  height: 55px;
}
</style>
